module.exports = __webpack_public_path__ + "img/ka1-2.2d30f3c5.png";